import React from "react";
import { TEMPLATES } from "@/constants/testIds";

const VIEWS = [
  { value: "editor", label: "Editor" },
  { value: "recipient", label: "Destinatario externo" },
];

export function PreviewViewToggle({ value, onChange }) {
  return (
    <div className="inline-flex p-0.5 rounded-md bg-slate-100 border border-slate-200" role="tablist">
      {VIEWS.map((v) => (
        <button key={v.value} type="button" role="tab" aria-selected={value === v.value}
          onClick={() => onChange(v.value)}
          className={`px-2.5 py-1 text-[11px] font-medium rounded transition-colors ${value === v.value ? "bg-white text-orange-700 shadow-sm" : "text-slate-500 hover:text-slate-800"}`}
          data-testid={TEMPLATES.previewView(v.value)}>
          {v.label}
        </button>
      ))}
    </div>
  );
}
